import { Grid } from '@mui/material';
import { DetailsRow } from 'lib/ClientDataDetails/DetailsRow';
import { generalEnum } from 'screens/Clients/utils/generalEnum';
import { useTranslation } from 'react-i18next';
import { BridgingRowProps } from 'types/Client';
import TemplateDetails from '../TemplateDetails';

export default function BridgingDetails({ translationsRoot, bridging }: BridgingRowProps) {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={12} md={6} p={2}>
        <TemplateDetails>
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.number`)}
            value={bridging.number}
            isLoanPart
          />
          <DetailsRow
            type="currency"
            label={t(`${translationsRoot}.principalSum`)}
            value={bridging.principalSum}
            isLoanPart
          />
          <DetailsRow
            type="currency"
            label={t(`${translationsRoot}.residualDebt`)}
            value={bridging.residualDebt}
            isLoanPart
          />
        </TemplateDetails>
      </Grid>
      <Grid item xs={12} md={6} p={2}>
        <TemplateDetails>
          <DetailsRow
            type="date"
            label={t(`${translationsRoot}.startDate`)}
            value={bridging.startDate}
            isLoanPart
          />
          <DetailsRow
            type="date"
            label={t(`${translationsRoot}.endDate`)}
            value={bridging.endDate}
            isLoanPart
          />
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.duration`)}
            value={bridging.duration}
            isLoanPart
          />
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.status`)}
            value={generalEnum('bridgingStatus', bridging.status)}
            isLoanPart
          />
        </TemplateDetails>
      </Grid>
    </Grid>
  );
}
